export default {
    '/us-ma/boston/us-ny/new-york/': {
        departPlace: 'Boston, MA, USA',
        arrivePlace: 'New York, NY, USA',
        metaTitle: 'Boston to New York Travel Options - Wanderu',
        metaDescription: 'Wanderu is the simplest way to compare travel options from Boston to New York',
        destinationPlaceId: 'ChIJOwg_06VPwokRYv534QaPC8g',
        originPlaceId: 'ChIJGzE9DS1l44kRoOhiASS_fHg',
        widgetTitle: 'Travel from Boston to New York',
        carousel: {
            title: 'Wanderu\'s Guide to New York',
            slides: [
                {
                    title: '5 Easy Ways to Enjoy New York City Without Going Broke',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/travel-to-new-york-on-a-budget/nyc_skyline.jpg',
                    imageCaption: 'New York City skyline',
                    href: 'https://www.wanderu.com/blog/travel-to-new-york-on-a-budget/',
                },
                {
                    title: '20 Free Things You Can Do in New York City',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/free-things-to-do-in-new-york/alexandra-nicolae-456304-unsplash.jpg',
                    imageCaption: 'New York City skyline',
                    href: 'https://www.wanderu.com/blog/free-things-to-do-in-new-york/',
                },
                {
                    title: 'Take NYC by Storm: The Best Things to Do in Midtown',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/all-the-places-you-can-visit-from-new-york-for-less-than-20/47_newyork.jpg',
                    imageCaption: 'New York City skyline',
                    href: 'https://www.wanderu.com/blog/nyc-summer-travel-guide/',
                },
            ],
        },
        carriers: [
            {
                carrierCode: 'USOUR',
                name: 'OurBus',
                pageSlug: 'ourbus-265',
            },
            {
                carrierCode: 'USCOR',
                name: 'CoachRun',
                pageSlug: 'coachrun-1258',
            },
            {
                carrierCode: 'USPPL',
                name: 'Peter Pan',
                pageSlug: 'peter-pan-bus-lines-132',
            },
            {
                carrierCode: 'USACL',
                name: 'Acela',
                pageSlug: 'acela-182',
            },
            {
                carrierCode: 'USFLX',
                name: 'FlixBus USA',
                pageSlug: 'flixbus-us-1956',
            },
        ],
        locationData: {
            arrival: {
                placeId: 'ChIJOwg_06VPwokRYv534QaPC8g',
                name: 'New York',
                wcityid: 'NYC',
                countryCode: 'US',
                countryName: 'United States',
                stateCode: 'NY',
                stateName: 'New York',
                timezone: 'America/New_York',
                latitude: 40.7127837,
                longitude: -74.0059413,
                formattedAddress: 'New York, NY, USA',
                state: 'NY',
            },
            departure: {
                placeId: 'ChIJGzE9DS1l44kRoOhiASS_fHg',
                name: 'Boston',
                wcityid: 'BOS',
                countryCode: 'US',
                countryName: 'United States',
                stateCode: 'MA',
                stateName: 'Massachusetts',
                timezone: 'America/New_York',
                latitude: 42.3600825,
                longitude: -71.0588801,
                formattedAddress: 'Boston, MA, USA',
                state: 'MA',
            },
        },
        modeData: {
            auto: {
                appeal: 'Flexibility',
                distanceDestination: 'Various',
                distanceOrigin: 'Various',
                duration: 4.25,
                price: 100,
                wait: 0.75,
            },
            bus: {
                appeal: 'Price',
                distanceDestination: '.5 miles',
                distanceOrigin: '1 mile',
                duration: 4.74,
                price: 15,
                wait: 0.25,
            },
            flight: {
                appeal: 'Short sitting time',
                distanceDestination: '8 miles',
                distanceOrigin: '3-4 miles',
                duration: 1.25,
                price: 105,
                wait: 2,
            },
            tags: {
                cheapest: ['bus'],
                closestDestination: ['bus', 'train'],
                closestOrigin: ['bus', 'train'],
                fastest: ['flight'],
                shortest: ['bus', 'train'],
            },
            train: {
                appeal: 'Scenic views',
                distanceDestination: '.5 miles',
                distanceOrigin: '1 mile',
                duration: 4.15,
                price: 110,
                wait: 0.25,
            },
        },
    },
    '/us-ny/new-york/us-ma/boston/': {
        departPlace: 'New York, NY, USA',
        arrivePlace: 'Boston, MA, USA',
        metaTitle: 'New York to Boston Travel Options - Wanderu',
        metaDescription: 'Wanderu is the simplest way to compare travel options from New York to Boston',
        destinationPlaceId: 'ChIJGzE9DS1l44kRoOhiASS_fHg',
        originPlaceId: 'ChIJOwg_06VPwokRYv534QaPC8g',
        widgetTitle: 'Travel from New York to Boston',
        carousel: {
            title: 'Wanderu\'s Guide to Boston',
            slides: [
                {
                    title: '15 Free Things You Can Do in Boston',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/free-guide-boston/BostonCommon_181615649-2.jpg',
                    imageCaption: 'Paul Revere Statue in Boston',
                    href: 'https://www.wanderu.com/blog/free-guide-boston/',
                },
                {
                    title: '11 Best Budget Hotels in Boston',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/budget-hotels-boston/corey-bruce-OJKfFrT8Sok-unsplash-1-1.jpg',
                    imageCaption: 'Side street in Boston, side view of brick building with hanging revolutionary flag',
                    href: 'https://www.wanderu.com/blog/budget-hotels-boston/',
                },
                {
                    title: 'Boston Travel Guide: History, Sailing, Food & More!',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/boston-summer-travel-guide/8654412780_cda33449f9_b-1.jpg',
                    imageCaption: 'Boston skyline',
                    href: 'https://www.wanderu.com/blog/boston-summer-travel-guide/',
                },
            ],
        },
        carriers: [
            {
                carrierCode: 'USOUR',
                name: 'OurBus',
                pageSlug: 'ourbus-265',
            },
            {
                carrierCode: 'USCOR',
                name: 'CoachRun',
                pageSlug: 'coachrun-1258',
            },
            {
                carrierCode: 'USPPL',
                name: 'Peter Pan',
                pageSlug: 'peter-pan-bus-lines-132',
            },
            {
                carrierCode: 'USACL',
                name: 'Acela',
                pageSlug: 'acela-182',
            },
            {
                carrierCode: 'USFLX',
                name: 'FlixBus USA',
                pageSlug: 'flixbus-us-1956',
            },
        ],
        locationData: {
            arrival: {
                placeId: 'ChIJGzE9DS1l44kRoOhiASS_fHg',
                name: 'Boston',
                wcityid: 'BOS',
                countryCode: 'US',
                countryName: 'United States',
                stateCode: 'MA',
                stateName: 'Massachusetts',
                timezone: 'America/New_York',
                latitude: 42.3600825,
                longitude: -71.0588801,
                formattedAddress: 'Boston, MA, USA',
                state: 'MA',
            },
            departure: {
                placeId: 'ChIJOwg_06VPwokRYv534QaPC8g',
                name: 'New York',
                wcityid: 'NYC',
                countryCode: 'US',
                countryName: 'United States',
                stateCode: 'NY',
                stateName: 'New York',
                timezone: 'America/New_York',
                latitude: 40.7127837,
                longitude: -74.0059413,
                formattedAddress: 'New York, NY, USA',
                state: 'NY',
            },
        },
        modeData: {
            auto: {
                appeal: 'Flexibility',
                distanceDestination: 'Various',
                distanceOrigin: 'Various',
                duration: 4.25,
                price: 100,
                wait: 0.75,
            },
            bus: {
                appeal: 'Price',
                distanceDestination: '1 mile',
                distanceOrigin: '.5 miles',
                duration: 4.74,
                price: 15,
                wait: 0.25,
            },
            flight: {
                appeal: 'Short sitting time',
                distanceDestination: '3-4 miles',
                distanceOrigin: '8 miles',
                duration: 1.25,
                price: 105,
                wait: 2,
            },
            tags: {
                cheapest: ['bus'],
                closestDestination: ['bus', 'train'],
                closestOrigin: ['bus', 'train'],
                fastest: ['flight'],
                shortest: ['bus', 'train'],
            },
            train: {
                appeal: 'Scenic views',
                distanceDestination: '1 mile',
                distanceOrigin: '.5 miles',
                duration: 4.15,
                price: 110,
                wait: 0.25,
            },
        },
    },
    '/us-dc/washington/us-ny/new-york/': {
        departPlace: 'Washington DC, DC, USA',
        arrivePlace: 'New York, NY, USA',
        metaTitle: 'Washington DC to New York Travel Options - Wanderu',
        metaDescription: 'Wanderu is the simplest way to compare travel options from Washington DC to New York',
        destinationPlaceId: 'ChIJOwg_06VPwokRYv534QaPC8g',
        originPlaceId: 'ChIJW-T2Wt7Gt4kRKl2I1CJFUsI',
        widgetTitle: 'Travel from Washington DC to New York',
        valuePropsPresent: true,
        modeData: {
            auto: {
                appeal: 'Flexibility',
                distanceDestination: 'Various',
                distanceOrigin: 'Various',
                duration: 3.25,
                price: 100,
                wait: 0.75,
            },
            bus: {
                appeal: 'Price',
                distanceDestination: '.5 miles',
                distanceOrigin: '.5 miles',
                duration: 3.75,
                price: 17,
                wait: 0.25,
            },
            train: {
                appeal: 'Scenic views',
                distanceDestination: '.5 miles',
                distanceOrigin: '.5 miles',
                duration: 2.75,
                price: 22,
                wait: 0.25,
            },
            flight: {
                appeal: 'Short sitting time',
                distanceDestination: '8 miles',
                distanceOrigin: '5 miles',
                duration: 1.5,
                price: 110,
                wait: 2,
            },
            tags: {
                cheapest: [
                    'bus',
                ],
                closestDestination: [
                    'bus',
                    'train',
                ],
                closestOrigin: [
                    'bus',
                    'train',
                ],
                fastest: [
                    'flight',
                ],
                shortest: [
                    'bus',
                    'train',
                ],
            },
        },
        carousel: {
            title: 'Wanderu\'s Guide to New York',
            slides: [
                {
                    title: '5 Easy Ways to Enjoy New York City Without Going Broke',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/travel-to-new-york-on-a-budget/nyc_skyline.jpg',
                    imageCaption: 'New York City skyline',
                    href: 'https://www.wanderu.com/blog/travel-to-new-york-on-a-budget/',
                },
                {
                    title: '20 Free Things You Can Do in New York City',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/free-things-to-do-in-new-york/alexandra-nicolae-456304-unsplash.jpg',
                    imageCaption: 'New York City skyline',
                    href: 'https://www.wanderu.com/blog/free-things-to-do-in-new-york/',
                },
                {
                    title: 'Take NYC by Storm: The Best Things to Do in Midtown',
                    imageUrl: 'https://static.wanderu.com/nexus/blog/all-the-places-you-can-visit-from-new-york-for-less-than-20/47_newyork.jpg',
                    imageCaption: 'New York City skyline',
                    href: 'https://www.wanderu.com/blog/nyc-summer-travel-guide/',
                },
            ],
        },
        carriers: [
            {
                carrierCode: 'USACL',
                name: 'Acela',
                pageSlug: 'acela-182',
            },
            {
                carrierCode: 'BST',
                name: 'BestBus',
                pageSlug: 'bestbus-157',
            },
            {
                carrierCode: 'USBBP',
                name: 'BestBus Prime',
                pageSlug: 'bestbus-prime-1245',
            },
            {
                carrierCode: 'USCOR',
                name: 'CoachRun',
                pageSlug: 'coachrun-1258',
            },
            {
                carrierCode: 'USFLX',
                name: 'FlixBus US',
                pageSlug: 'flixbus-206',
            },
            {
                carrierCode: 'GLI',
                name: 'Greyhound',
                pageSlug: 'greyhound-bus-lines-139',
            },
            {
                carrierCode: 'USOUR',
                name: 'OurBus',
                pageSlug: 'ourbus-265',
            },
            {
                carrierCode: 'USPPL',
                name: 'Peter Pan Lines',
                pageSlug: 'peter-pan-bus-lines-132',
            },
            {
                carrierCode: 'USTJC',
                name: 'The Jet',
                pageSlug: 'the-jet-2038',
            },
            {
                carrierCode: 'USTRP',
                name: 'Tripper Bus',
                pageSlug: 'tripper-bus-1987',
            },
            {
                carrierCode: 'USWAD',
                name: 'Wanda Coach',
                pageSlug: 'wanda-coach-1076',
            },
            {
                carrierCode: 'WDX',
                name: 'Washington Deluxe ',
                pageSlug: 'washington-deluxe-127',
            },
        ],
        locationData: {
            arrival: {
                placeId: 'ChIJOwg_06VPwokRYv534QaPC8g',
                name: 'New York',
                wcityid: 'NYC',
                countryCode: 'US',
                countryName: 'United States',
                stateCode: 'NY',
                stateName: 'New York',
                timezone: 'America/New_York',
                latitude: '40.7127837',
                longitude: '-74.0059413',
                formattedAddress: 'New York, NY, USA',
            },
            departure: {
                placeId: 'ChIJW-T2Wt7Gt4kRKl2I1CJFUsI',
                name: 'Washington',
                wcityid: 'DCA',
                countryCode: 'US',
                countryName: 'United States',
                stateCode: 'MA',
                stateName: 'DC',
                timezone: 'America/New_York',
                latitude: '38.9071923',
                longitude: '-77.0368707',
                formattedAddress: 'Washington, DC, USA',
            },
        },
    },
};
